// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dhmB","content":"styles_content__1yV7t","row":"styles_row__38BzV","footer":"styles_footer__271Bl","phraseLength":"styles_phraseLength__fraRd"};